// extracted by mini-css-extract-plugin
module.exports = {"tr":"OverviewTable_tr__A0_5j"};